import React, { Component } from "react";
import FeeCard from "../../Components/Payments/FeeCard";
import PaidFeeCard from "../../Components/Payments/PaidFeeCard";
import { Link } from "react-router-dom";
import Header from "../../Components/MainLayout/Header";
import Axios from "axios";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

const FeeStatusCategory = ["Due Fee", "Paid Fee"];
class Payments extends Component {
  state = {
    collectfee: [],
    collectfeePaid: [],
    loading: false,
    fakeData: [1, 2, 3, 4],
    currentTab: 0,
  };

  componentDidMount() {
    if (this.props?.user?.id) {
      this.fetchfee({
        school: this.props?.user?.user?.school?.id,
        student: this.props?.user?.id,
        session: this.props?.user?.student_info?.session?.id,
        paid_status: false,
      });
      this.fetchPaid({ student_info: this.props.user?.student_info?.id });
    }
  }

  fetchfee = (params = {}) => {
    this.setState({ loading: true });
    Axios.get(`/api/collectfee`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({ collectfee: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchPaid = (params = {}) => {
    this.setState({ loading: true });
    Axios.get(`/api/mReceiptTermWise`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({ collectfeePaid: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    console.log(this, "state in payment");
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      year1 = year1 % 100;

      return `${handelDt(dt1)} ${monthNames[month1]}  ${year1}`;
    };
    return (
      <div>
        <Header to="/home" title="Payments" />

        <div
          className="d-flex flex-row th-no-scroll pt-2"
          style={{ overflowX: "scroll" }}
        >
          {FeeStatusCategory?.map((item, index) => {
            return (
              <div
                key={index}
                className="pl-3 pr-4 text-center th-cap th-14 py-2"
                onClick={() => this.setState({ currentTab: index })}
              >
                <div
                  className={
                    this.state.currentTab === index
                      ? "th-primary th-medium"
                      : "th-black"
                  }
                >
                  {item}
                </div>
                {this.state.currentTab === index ? (
                  <hr
                    className="w-100 my-1 th-border"
                    style={{ borderWidth: 5, borderRadius: 5 }}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
        {this.state.currentTab === 0 ? (
          <React.Fragment>
            {this.props.user.user?.sms_number ? (
              <div
                className="text-center position-fixed w-100"
                style={{ bottom: 80, zIndex: 100 }}
              >
                {this.state.collectfee.length === 0 ? null : (
                  <Link
                    type="button"
                    className="th-btn-primary shadow py-2 px-3"
                    to="/feePayment"
                  >
                    PROCEED TO PAYMENT
                  </Link>
                )}
              </div>
            ) : (
              <div
                className="text-center position-fixed d-flex justify-content-center w-100"
                style={{ bottom: 80, zIndex: 100 }}
              >
                {" "}
                <div className="th-btn-primary py-2 px-3 ">
                  Contact admin to add your sms number
                </div>
              </div>
            )}

            {this.state.loading ? (
              <div className="container pt-3">
                {this.state.fakeData?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="border p-3 shadow-sm rounded-lg mb-3"
                    >
                      <Skeleton width={100} />
                      <Skeleton count={2} />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="container pt-3 pb-5">
                <p className="th-14 th-bold mb-2">Due Fee</p>

                {this.state.collectfee.length === 0 ? (
                  <p className="th-12 text-center py-5">All dues paid.</p>
                ) : (
                  this.state.collectfee?.map((item, index) => {
                    return (
                      <div key={index}>
                        <FeeCard
                          title={
                            item.fee_group
                              ? item.fee_group.term_fee.term_name
                              : "Back Due Of Last Session"
                          }
                          date={
                            item.fee_group
                              ? handleDate(item.fee_group.term_fee.due_date)
                              : "Earliest Possible"
                          }
                          amount={item.total_fee}
                          balance={item.total_fee - item.paid_fee}
                          detail={item.collect_fee_data}
                        />
                      </div>
                    );
                  })
                )}
                <div className="py-3"></div>
              </div>
            )}
          </React.Fragment>
        ) : (
          <>
            {this.state.loading ? (
              <div className="container pt-3">
                {this.state.fakeData?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="border p-3 shadow-sm rounded-lg mb-3"
                    >
                      <Skeleton width={100} />
                      <Skeleton count={2} />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="container pt-3 pb-5">
                <p className="th-14 th-bold mb-2">Paid Fee</p>

                {this.state.collectfeePaid.length === 0 ? (
                  <p className="th-12 text-center py-5">All dues paid.</p>
                ) : (
                  this.state.collectfeePaid?.map((item, index) => {
                    return (
                      <div key={index}>
                        <PaidFeeCard
                          title={item.term_name_data}
                          amount={item.total_fee + item.adjustment_fee}
                          balance={item.balance}
                          detail={item.fee_details}
                          amountPaid={item.amount_paid}
                        />
                      </div>
                    );
                  })
                )}
                <div className="py-3"></div>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps)(Payments);
